import { useRouter } from 'next/router';
import { jsonLdScriptProps } from 'react-schemaorg';
import { WebPage } from 'schema-dts';

const useSchemaWebPage = ({
  name,
  description,
}: {
  name: string;
  description: string;
}) => {
  const { locale = 'en', asPath } = useRouter();
  const localePath = locale !== 'en' ? `/${locale}` : '';
  const cleanAsPathForCanonicalURL = asPath.split('?')[0];

  return jsonLdScriptProps<WebPage>({
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${process.env.NEXT_PUBLIC_HOST}${localePath}${cleanAsPathForCanonicalURL}#webpage`,
    url: `${process.env.NEXT_PUBLIC_HOST}${localePath}${cleanAsPathForCanonicalURL}`,
    inLanguage: locale,
    name,
    description,
    breadcrumb: {
      '@id': `${process.env.NEXT_PUBLIC_HOST}${localePath}${cleanAsPathForCanonicalURL}#breadcrumb`,
    },
  });
};

export default useSchemaWebPage;
